import { create } from 'zustand';
import { Profile } from '@/types/profile.types';

interface ProfileState {
  profiles: Profile[];
  selectedProfile: Profile | null;
  setProfiles: (profiles: Profile[]) => void;
  setSelectedProfile: (profile: Profile) => void;
  getProfileByLanguage: (language: string) => Profile | undefined;
  makeProfileDefault: (profileId: string) => void;
}

export const useProfileStore = create<ProfileState>((set, get) => ({
  profiles: [],
  selectedProfile: null,
  setProfiles: (profiles) => set({ profiles }),
  setSelectedProfile: (profile) => set({ selectedProfile: profile }),
  getProfileByLanguage: (language) => {
    const { profiles } = get();
    return profiles.find((profile) => profile.language === language);
  },
  makeProfileDefault: (profileId) => {
    const { profiles } = get();
    const updatedProfiles = profiles.map(profile => ({
      ...profile,
      isDefault: profile._id === profileId
    }));
    const updatedSelectedProfile = updatedProfiles.find(profile => profile._id === profileId) || null;
    set({ 
      profiles: updatedProfiles,
      selectedProfile: updatedSelectedProfile
    });
  },
}));
